import { render, staticRenderFns } from "./UserRemoveModal.vue?vue&type=template&id=148513fe&"
import script from "./UserRemoveModal.vue?vue&type=script&lang=js&"
export * from "./UserRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports